export function isExtensionAvailable(_name: string): boolean {
  return false;
}

export function useExtensionChecker() {
  return {
    check: () => false,
    isExtensionAvailable: (_name: string) => false,
    extensions: [] as string[],
  };
}
